export const formatPhoneNumber = (phoneNumber: string): string => {
  const numbers = phoneNumber.replace(/[^0-9]/g, '');
  if (numbers.length === 11) {
    const [first, ...rest] = numbers;
    return `+${first}${formatPhoneNumber(rest.join(''))}`;
  }
  return `(${numbers.substring(0, 3)}) ${numbers.substring(3, 6)}-${numbers.substring(6)}`;
};
